module.exports = {
  Scene3D: {
    PluginName: "3B Obje",
    Empty: "3B obje bulunamadı",
    InteractOn: "Çevir",
    InteractOff: "✓ Çevirme açık",
    InteractOnHint: "Objeyi çevirmek/patlatmak için aç",
    InteractOffHint: "Kutuyu taşımak için kapat",
  },
};
